import { useState, useEffect } from 'react'
import { useInfiniteScroll } from 'react-infinite-scroll-hook'
import { Card, Stack } from '@leroy-merlin-br/backyard-react-ui'

import { error } from 'scripts/utils/message'

import { List } from 'lmcv/components/BalanceList'
import { getProfileLoyalty, getProfileBalance } from 'lmcv/services/profile'
import { message } from 'lmcv/modules/helpers'

import { Points } from './components/Points'

function MyPointsPage () {
  const [user, setUser] = useState({})
  const [userLoading, setUserLoading] = useState(true)
  const [balance, setBalance] = useState([])
  const [loading, setLoading] = useState(false)
  const [getting, setGetting] = useState(false)
  const [listLoading, setListLoading] = useState(true)

  const [hasNextPage, setHasNextPage] = useState(true)
  const [page, setPage] = useState(1)

  useEffect(() => {
    getProfileLoyalty()
      .then(data => {
        setUser(data)
        setUserLoading(false)
      })
      .catch(e => error(message.error('seu perfil')))
  }, [])

  const handleLoadMore = () => {
    setLoading(true)

    getProfileBalance(page)
      .then(({ data, meta }) => {
        if (!meta.next_page) {
          setHasNextPage(false)
        }

        if (meta.current_page > 1) {
          setGetting(true)
        }

        setPage(page + 1)
        setGetting(false)
        setBalance([...balance, ...data])
      })
      .catch(e => error(message.error('seu saldo de pontos')))
      .finally(() => {
        setLoading(false)
        setListLoading(false)
      })
  }

  const ListRef = useInfiniteScroll({
    loading,
    hasNextPage,
    onLoadMore: handleLoadMore,
    scrollContainer: 'window',
    threshold: 600
  })

  return (
    <Stack>
      <Card title="Meus Pontos">
        <Points user={user} isLoading={userLoading} />
      </Card>

      <Card title="Saldo de pontos">
        <div ref={ListRef}>
          <List data={balance} isLoading={listLoading} isGetting={getting} />
        </div>
      </Card>
    </Stack>
  )
}

export default MyPointsPage
